var Helpers = (function () {
    function Helpers() {
    }
    Helpers.trim = function (str) {
        return str.replace(/^\s*/, '').replace(/\s*$/, '');
    };
    return Helpers;
}());

var XHRCore = (function () {
    function XHRCore() {
    }
    XHRCore.initRequestConfig = function (method, url, xhr) {
        return {
            method: method.toUpperCase(),
            url: url,
            baseURL: '',
            headers: {},
            timeout: xhr.timeout || 0,
            withCredentials: xhr.withCredentials || false
        };
    };
    XHRCore.getResponse = function (xhr, requestUrl) {
        return {
            url: xhr.responseURL || requestUrl,
            data: this.getResponseData(xhr),
            status: xhr.status,
            statusText: xhr.statusText,
            headers: this.getResponseHeaders(xhr)
        };
    };
    XHRCore.getResponseData = function (xhr) {
        var resData = {};
        var type = Object.prototype.toString.call(xhr.response);
        if (type === '[object Object]') {
            return xhr.response;
        }
        else if (type === '[object Null]') {
            return {};
        }
        try {
            resData = JSON.parse(xhr.response);
        }
        catch (err) {
            console.log(err);
        }
        return resData;
    };
    XHRCore.getResponseHeaders = function (xhr) {
        var headers = {};
        if (!('getAllResponseHeaders' in xhr))
            return headers;
        return this.parseHeaders(xhr.getAllResponseHeaders());
    };
    XHRCore.parseHeaders = function (headersStr) {
        var headers = {};
        if (!headersStr)
            return headers;
        var headerList = Helpers.trim(headersStr).split(/[\r\n]+/);
        headerList.forEach(function (line) {
            var index = line.indexOf(':');
            var key = Helpers.trim(line.substr(0, index)).toLowerCase();
            var val = Helpers.trim(line.substr(index + 1));
            if (!key)
                return;
            headers[key] = headers[key] ? headers[key] + ', ' + val : val;
        });
        return headers;
    };
    XHRCore.setRequestHeaders = function (headers, xhr) {
        if (headers === void 0) { headers = {}; }
        if (!('setRequestHeader' in xhr))
            return;
        Object.keys(headers).forEach(function (key) {
            if (!headers.hasOwnProperty(key))
                return;
            xhr.setRequestHeader(key, headers[key]);
        });
    };
    return XHRCore;
}());

var CommonCore = (function () {
    function CommonCore() {
    }
    CommonCore.getRequestHandlers = function () {
        var handlers = [];
        try {
            handlers = window._requestInterceptor.request.getHandlers();
        }
        catch (err) {
            console.log(err);
        }
        return handlers;
    };
    CommonCore.getResponseHandlers = function () {
        var handlers = [];
        try {
            handlers = window._requestInterceptor.response.getHandlers();
        }
        catch (err) {
            console.log(err);
        }
        return handlers;
    };
    CommonCore.checkInstanceIsInited = function () {
        var _requestInterceptor = window._requestInterceptor;
        return Boolean(_requestInterceptor && _requestInterceptor.request && _requestInterceptor.response);
    };
    return CommonCore;
}());

var XHRInterceptor = (function () {
    function XHRInterceptor() {
    }
    XHRInterceptor.patch = function () {
        if (!(typeof window !== "undefined" && window.XMLHttpRequest))
            return;
        var config = {
            method: '',
            url: ''
        };
        var _url;
        var proto = window.XMLHttpRequest.prototype;
        var _open = proto.open;
        proto.open = function (method, url, async, user, password) {
            _url = url;
            if (async === undefined) {
                async = true;
            }
            if (user === undefined) {
                user = null;
            }
            if (password === undefined) {
                password = null;
            }
            var requestHandlers = CommonCore.getRequestHandlers();
            if (Array.isArray(requestHandlers) && requestHandlers.length) {
                config = XHRCore.initRequestConfig(method, url, this);
                requestHandlers.forEach(function (handler) {
                    var fulfilled = handler.fulfilled;
                    var duplicateConfig = Object.assign({}, config);
                    config = fulfilled(duplicateConfig) || duplicateConfig;
                });
                _url = config.baseURL || '';
                _url += config.url || url;
                this.withCredentials = config.withCredentials || false;
                this.timeout = config.timeout || 0;
            }
            _open.call(this, method, _url, Boolean(async), user, password);
        };
        var _send = proto.send;
        proto.send = function (body) {
            var _this = this;
            XHRCore.setRequestHeaders(config.headers, this);
            this.addEventListener('readystatechange', function () {
                if (_this.readyState !== 4)
                    return;
                var responseHandlers = CommonCore.getResponseHandlers();
                if (Array.isArray(responseHandlers) && responseHandlers.length) {
                    var response = XHRCore.getResponse(_this, _url);
                    var resPromise_1 = Promise.resolve(response);
                    responseHandlers.forEach(function (handler) {
                        resPromise_1 = resPromise_1.then(handler.fulfilled, handler.rejected);
                    });
                    resPromise_1.catch(function (err) {
                        console.log(err);
                        return Promise.reject(err);
                    });
                }
            });
            _send.call(this, body);
        };
    };
    return XHRInterceptor;
}());
if (!CommonCore.checkInstanceIsInited())
    XHRInterceptor.patch();

var FetchCore = (function () {
    function FetchCore() {
    }
    FetchCore.initRequestConfig = function (url, requestInit) {
        if (requestInit === void 0) { requestInit = {}; }
        return {
            method: (requestInit.method || 'get').toUpperCase(),
            url: url,
            baseURL: '',
            headers: requestInit.headers || {},
            withCredentials: this.convertCredentials(requestInit.credentials),
            mode: requestInit.mode,
            cache: requestInit.cache
        };
    };
    FetchCore.convertCredentials = function (credentials) {
        if (credentials === void 0) { credentials = 'omit'; }
        if (credentials === 'include')
            return true;
        return false;
    };
    FetchCore.cloneRequest = function (request, url) {
        var RequestConfigProperties = [
            'url', 'method', 'headers', 'body', 'mode', 'cache', 'credentials',
            'keepalive', 'destination', 'referrer', 'referrerPolicy', 'redirect',
            'integrity', 'signal', 'isHistoryNavigation', 'isReloadNavigation', 'bodyUsed'
        ];
        var requestConfig = {};
        for (var key in request) {
            if (RequestConfigProperties.indexOf(key) > -1) {
                requestConfig[key] = request[key];
            }
        }
        return new Request(url, requestConfig);
    };
    FetchCore.getResponse = function (res) {
        return {
            url: res.url,
            data: this.getResponseData(res),
            status: res.status,
            statusText: res.statusText,
            headers: this.getResponseHeaders(res.headers)
        };
    };
    FetchCore.getResponseData = function (res) {
        var resData = {};
        try {
            var _res = res.clone();
            resData = _res.json();
        }
        catch (err) {
            console.log(err);
        }
        return resData;
    };
    FetchCore.getResponseHeaders = function (headers) {
        var resHeaders = {};
        try {
            headers.forEach(function (val, key) {
                resHeaders[key] = val;
            });
        }
        catch (err) {
            console.log(err);
        }
        return resHeaders;
    };
    return FetchCore;
}());

var FetchInterceptor = (function () {
    function FetchInterceptor() {
    }
    FetchInterceptor.patch = function () {
        if (!(typeof window !== "undefined" && window.fetch))
            return;
        var config;
        var _fetch = window.fetch;
        var patchedFetch = function (input, init) {
            if (!input)
                throw new TypeError("Failed to execute 'fetch' on 'Window': 1 argument required, but only 0 present.");
            var url = typeof input === "string" ? input : input.url;
            var _init = init ? init : {};
            var _url = '';
            var _input = input;
            var originResponse;
            var promise;
            var requestHandlers = CommonCore.getRequestHandlers();
            var responseHandlers = CommonCore.getResponseHandlers();
            if (Array.isArray(requestHandlers) && requestHandlers.length) {
                config = FetchCore.initRequestConfig(url, init);
                promise = Promise.resolve(config);
                requestHandlers.forEach(function (handler) {
                    promise = promise.then(handler.fulfilled, handler.rejected);
                });
                promise = promise.then(function (config) {
                    _url = config.baseURL || '';
                    _url += config.url || url;
                    if (typeof input !== 'string' && input instanceof Request) {
                        _input = (FetchCore.cloneRequest(input, _url));
                    }
                    else {
                        _input = _url;
                    }
                    _init.credentials = config.withCredentials ? 'include' : 'same-origin';
                    _init.headers = Object.assign({}, _init.headers, config.headers);
                    _init.cache = config.cache || _init.cache;
                    _init.mode = config.mode || _init.mode;
                    return _init;
                });
            }
            else {
                promise = Promise.resolve(_init);
            }
            promise = promise.then(function (requestInit) {
                return _fetch(_input, requestInit).then(function (res) {
                    originResponse = res;
                    return res;
                });
            });
            if (Array.isArray(responseHandlers) && responseHandlers.length) {
                promise = promise.then(function (res) {
                    var response = FetchCore.getResponse(res);
                    if (response.data instanceof Promise) {
                        return new Promise(function (resolve) {
                            response.data.then(function (resData) {
                                response.data = resData;
                                resolve(response);
                            });
                        });
                    }
                    return Promise.resolve(response);
                });
                responseHandlers.forEach(function (handler) {
                    promise = promise.then(handler.fulfilled, handler.rejected);
                });
            }
            return promise.then(function () {
                return originResponse;
            });
        };
        window.fetch = patchedFetch;
    };
    return FetchInterceptor;
}());
if (!CommonCore.checkInstanceIsInited())
    FetchInterceptor.patch();

var HandlerManager = (function () {
    function HandlerManager() {
        this.handlers = [];
    }
    HandlerManager.prototype.add = function (handler) {
        this.handlers.push(handler);
    };
    HandlerManager.prototype.remove = function (handler) {
        var currentIndex = -1;
        this.handlers.some(function (item, index) {
            if (item === handler) {
                currentIndex = index;
                return true;
            }
            return false;
        });
        if (currentIndex > -1) {
            this.handlers.splice(currentIndex, 1);
            return true;
        }
        return false;
    };
    HandlerManager.prototype.list = function () {
        return this.handlers;
    };
    return HandlerManager;
}());

var InterceptorManager = (function () {
    function InterceptorManager() {
        this.handler = new HandlerManager();
    }
    InterceptorManager.prototype.use = function (fulfilled, rejected) {
        var handler = {
            fulfilled: fulfilled,
            rejected: rejected
        };
        this.handler.add(handler);
    };
    InterceptorManager.prototype.getHandlers = function () {
        return this.handler.list();
    };
    return InterceptorManager;
}());

var interceptor = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
};
if (!CommonCore.checkInstanceIsInited())
    window._requestInterceptor = interceptor;
var index = window._requestInterceptor;

export default index;
//# sourceMappingURL=index.esm.js.map
